import styled from "@emotion/styled/macro";
import { Global, css } from "@emotion/react";
import { useTheme } from "@chakra-ui/react";

import Header from "../Header";
import Footer from "../Footer";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  max-width: 1280px;
  margin: 0 auto;
`;
const HeaderWrapper = styled.div`
  box-shadow: 1px -17px 24px 9px ${({ theme }) => theme.colors.opal};
  z-index: 1;
  clip-path: inset(0px 0px -24px 0px);
  background: ${({ theme }) => theme.colors.white};
`;

const Main = styled.div`
  flex: 1;
`;

const Layout = ({ children }) => {
  const theme = useTheme();

  return (
    <>
      <Global
        styles={css`
          body {
            background: ${theme.colors.footer};
          }
        `}
      />
      <Wrapper>
        <HeaderWrapper>
          <Header />
        </HeaderWrapper>

        <Main>{children}</Main>
        <Footer />
      </Wrapper>
    </>
  );
};

export default Layout;
